import { Object3D } from 'three';

export const mirror_plane_name = 'mirror_plane';

export function is_mirror_plane(x: Object3D) {
    return x.name === mirror_plane_name;
}
